import * as React from 'react';
import { useState } from 'react';

import styled from '@emotion/styled';

import { Spacer } from '@shared/components/helpers';
import { useDebounce } from '@shared/hooks';

import { Panel } from '@admin/components/helpers/panel';
import { Pagination } from '@admin/components/pagination';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { usePaginatedSelfStorageUnitsQuery, SelfStorage__Unit__FiltersInput } from '@admin/schema';

import { Filters } from './filters';
import { Table } from './table';

const SpinnerWrapper = styled.div`
  display: flex;
`;

export const SelfStorageUnits: React.FC = () => {
  useTitle('Self-Storage Units');
  const [page, setPage] = useState<number | undefined>(undefined);
  const [filters, setFilters] = useState<SelfStorage__Unit__FiltersInput>({});

  const { data, loading } = usePaginatedSelfStorageUnitsQuery({
    client,
    variables: {
      page,
      filters: {
        ...filters,
        search: useDebounce(filters.search),
      },
    },
  });

  const paginated = data && data.paginated;

  return (
    <Panel>
      <Panel.Header>
        <Panel.Title>Self-Storage Prices & Availability</Panel.Title>
      </Panel.Header>
      <Panel.Body>
        <Filters
          filters={filters}
          onFilter={(value) => {
            setFilters(value);
            setPage(undefined);
          }}
        />
        <Spacer height="8px" />
        {loading && (
          <>
            <SpinnerWrapper>
              <Spinner />
            </SpinnerWrapper>
            <Spacer height="8px" />
          </>
        )}
        <Table units={paginated?.results ?? []} />
        {paginated && <Pagination pagination={paginated.pagination} onPage={setPage} />}
      </Panel.Body>
    </Panel>
  );
};
